import Enum from './enum'

class BidRuleFormula extends Enum
{
  constructor(value) {
    super(value);
  }
}

BidRuleFormula.init({
  PERCENT: true,
  EXACT: false
}, {
  PERCENT: 'bid-rule-formula.percent',
  EXACT: 'bid-rule-formula.exact'
});

export default BidRuleFormula;
